import React from 'react';
import { StepsBannerArrows } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';
import '../updateContactDetails.scss';
import UpdateContact from '../../../components/updateContact/updateContact';
import { CSPUrlsMap } from '../../../routes/CSPUrlsMap';
import { FORM_KEYS } from '../../../constants/formKeys';
import VerifyCode from '../../../components/verifyCode/verifyCode';
import { SuccessMessageDialog } from '../../../components/successMessage/successMessageDialog';
import useUpdatePhone from './useUpdatePhone';
import Loading from '../../../components/shared/Loading/Loading';

const UpdatePhone = () => {
  const {
    steps,
    isUpdatePhoneStep,
    onUpdateClick,
    onCancelClick,
    onInputChange,
    validation,
    ausNumberWithCountryCode,
    getVerifyCode,
    isCodeSent,
    isCodeVerified,
    confirmUserEnrollment,
    errorMessage,
    timeLeft,
    navigate,
    contactDetailsLoading
  } = useUpdatePhone();

  return (
    <div className="updateContactDetailsContainer">
      <StepsBannerArrows steps={steps} />
      {contactDetailsLoading && <Loading />}
      {isUpdatePhoneStep && (
        <UpdateContact
          type="phone"
          title=" Update your number"
          inputLabel="New phone number"
          inputName={FORM_KEYS.NEW_MOBILE_NUMBER}
          onUpdateClick={onUpdateClick}
          onCancelClick={onCancelClick}
          onInputChange={onInputChange}
          validation={validation}
          errorMessage={errorMessage}
        />
      )}
      {/* Verify new mobile number */}
      {!isUpdatePhoneStep && !isCodeVerified && (
        <VerifyCode
          type="sms"
          typeValue={ausNumberWithCountryCode}
          title="SMS Verification"
          handleSendCode={getVerifyCode}
          handleVerifyCode={confirmUserEnrollment}
          isCodeSent={isCodeSent}
          errorMessage={errorMessage}
          timeLeft={timeLeft}
        />
      )}
      {isCodeVerified && (
        <SuccessMessageDialog
          message="Thank you - Your request to change your mobile number has been received. Please note that it might take a few minutes for your new mobile number to take effect."
          closeButtonLabel="Continue"
          onClose={() => navigate(CSPUrlsMap.accountDetails.url)}
        />
      )}
    </div>
  );
};

export default UpdatePhone;
